<mat-card>
    <mat-toolbar>
    {{'utes.titol' | translate }}
    <span class="fill-remaining-space"></span>
    <div style="width:100%;float:right">
      <button mat-icon-button matTooltip="{{'utes.exportToolTip' | translate}}" attr.aria-label="{{'utes.exportToolTip' | translate}}" 
        matTooltipClass="tooltip-style" (click)="exportar()" style="float: right; margin-right: 0">
          <mat-icon color="primary" style="font-size:24px">vertical_align_bottom</mat-icon>
      </button>
      <button mat-icon-button style="float: right; width:70px; margin-right: 0" (click)="addUtes()" matTooltip="{{'utes.nova' | translate}}" attr.aria-label="{{'utes.nova' | translate}}" matTooltipClass="tooltip-style">
          <mat-icon color="primary" style="font-size:24px">add</mat-icon>
      </button>
      <button mat-icon-button matTooltip="{{'utes.filtre' | translate}}"  attr.aria-label="{{'utes.filtre' | translate}}" matTooltipClass="tooltip-style" (click)="toggleFiltersVisibility()" style="float: right; margin-right: 0">
        <mat-icon color="primary" style="font-size:24px">filter_list</mat-icon>
      </button>
    </div> 
  </mat-toolbar>
   <mcrit-gestio-utes-filters
     *ngIf="showFilters"
     [validFilters]="utesFilters"
     (changeFilter)="computeActiveFilters($event)">
   </mcrit-gestio-utes-filters>
   <mat-progress-bar mode="indeterminate" color="warm" *ngIf="showAsyncProgress" style="position: absolute;"></mat-progress-bar>
   <mat-card style="padding: 24px;width:95%">
    <table style="padding-top:40px;width:100%" mat-table [dataSource]="utesData" class="mat-elevation-z8" >
     <ng-container matColumnDef="codi">
       <th mat-header-cell *matHeaderCellDef> {{ 'utes.colCodi' | translate }} </th>
       <td mat-cell *matCellDef="let element"> {{element.codi}} </td>
     </ng-container>
     <ng-container matColumnDef="nom">
       <th mat-header-cell *matHeaderCellDef> {{ 'usuaris.colNom' | translate }} </th>
       <td mat-cell *matCellDef="let element"> {{element.nom}} </td>
     </ng-container>
     <ng-container matColumnDef="nif">
       <th mat-header-cell *matHeaderCellDef> {{ 'utes.colNIF' | translate }} </th>
       <td mat-cell *matCellDef="let element"> {{element.nif}} </td>
     </ng-container>
     <ng-container matColumnDef="codi1">
       <th mat-header-cell *matHeaderCellDef> {{ 'utesTable.colAltres' | translate }} </th>
       <td mat-cell *matCellDef="let element"> {{element.codi1}} </td>
     </ng-container>
     <ng-container matColumnDef="gerent">
       <th mat-header-cell *matHeaderCellDef> {{ 'utes.colGerent' | translate }} </th>
       <td mat-cell *matCellDef="let element"> {{element.gerent}} </td>
     </ng-container>
     <ng-container matColumnDef="gestiona">
       <th mat-header-cell *matHeaderCellDef> {{ 'utesTable.colGestionada' | translate }} </th>
       <td mat-cell *matCellDef="let element"> {{element.gestiona}} </td>
     </ng-container>
     <ng-container matColumnDef="alta">
       <th mat-header-cell *matHeaderCellDef> {{ 'utesTable.colAlta' | translate }} </th>
       <td mat-cell *matCellDef="let element"> {{element.alta}} </td>
     </ng-container>
     <ng-container matColumnDef="inoperativa">
       <th mat-header-cell *matHeaderCellDef> {{ 'utesTable.colInoperativa' | translate }} </th>
       <td mat-cell *matCellDef="let element"> {{element.inoperativa}} </td>
     </ng-container>
     <ng-container matColumnDef="baixa">
       <th mat-header-cell *matHeaderCellDef> {{ 'utesTable.colBaixa' | translate }} </th>
       <td mat-cell *matCellDef="let element"> {{element.baixa}} </td>
     </ng-container>
     <ng-container matColumnDef="caducitat_digital" attr.title="{{ 'utesTable.colCaducitat_digital' | translate }}">
       <th mat-header-cell *matHeaderCellDef> {{ 'utesTable.colCaducitat' | translate }} </th>
       <td mat-cell *matCellDef="let element"> {{element.caducitat_digital}} </td>
     </ng-container>
     <ng-container matColumnDef="capital_social" attr.title="{{ 'utes.colCapital_social' | translate }}">
       <th mat-header-cell *matHeaderCellDef> {{ 'utesTable.colCapital' | translate }} </th>
       <td mat-cell *matCellDef="let element"> {{element.capital_social}} </td>
     </ng-container>
     <ng-container matColumnDef="percent_propi">
       <th mat-header-cell *matHeaderCellDef attr.title="{{ 'utes.colPercent_propi' | translate }}"> {{ 'utesTable.colPercent' | translate }} </th>
       <td mat-cell *matCellDef="let element"> {{element.percent_propi}} </td>
     </ng-container>

     <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
     <tr mat-row *matRowDef="let row; columns: displayedColumns;" (click)="this.editUtes(row)" style="cursor: pointer"></tr>
    </table>
  </mat-card>
  <mat-toolbar class="footer">
    <span class="fill-remaining-space"></span>
    <span style="padding-right: 1em">
      {{'utes.liniesPag' | translate}}: {{listUtesService.rowsPerPage}}
      <button mat-icon-button [mat-menu-trigger-for]="menuNumberRows">
        <mat-icon>arrow_drop_down</mat-icon>
      </button>
    </span>
    <span style="padding-right: 1em">
      {{'utes.pagina' | translate}}:
    </span>
    <button mat-icon-button (click)="requestPrevious()">
      <mat-icon>keyboard_arrow_left</mat-icon>
    </button>
    <span style="text-align:center;width:20px">{{listUtesService.currentPage+1}}</span>
    <button mat-icon-button (click)="requestNext()">
      <mat-icon>keyboard_arrow_right</mat-icon>
    </button>
  </mat-toolbar>
 <mat-menu #menuNumberRows y-position="above">
     <button mat-menu-item *ngFor="let value of rowsPerPageOptions" (click)="setRowPerPage(value)">{{value}}</button>
 </mat-menu>
</mat-card>
